<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
          {{
          schemeType === "rev"
          ? "Q-bid Opening and CST"
          : "Financial Evaluation"
          }}
        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button type="button" class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="bi bi-file-earmark-pdf me-1"></i> PDF
        </button>
        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <!-- Q-CST Specific Fields -->
  <div class="card shadow-sm border-0 p-4 mb-4" *ngIf="isQcstStep">
    <h5 class="mb-3 text-primary">Q-Bid Opening Details</h5>
    <div class="row g-3">
      <div class="col-md-6">
        <label for="qbid_date" class="form-label">Q-Bid Opening Date</label>
        <input type="date" id="qbid_date" class="form-control" [(ngModel)]="qbid_date"
          [disabled]="!stepDetails?.can_edit" />
      </div>
      <div class="col-md-6">
        <label for="qbid_time" class="form-label">Time</label>
        <input type="time" id="qbid_time" class="form-control" [(ngModel)]="qbid_time"
          [disabled]="!stepDetails?.can_edit" />
      </div>
    </div>
    <div class="row g-3 mt-0">
      <div class="col-md-6">
        <label for="qbid_venue" class="form-label">Venue</label>
        <textarea id="qbid_venue" class="form-control" [(ngModel)]="qbid_venue" placeholder="Enter venue" rows="3"
          [disabled]="!stepDetails?.can_edit"></textarea>
      </div>
      <div class="col-md-6">
        <label for="cst_approval" class="form-label">CST Approval Date</label>
        <input type="date" id="cst_approval" class="form-control" [(ngModel)]="cst_approval" [disabled]="true" />
        <p class="text-xs text-red-600 italic mt-1">
          This field will be automatically populated.
        </p>
      </div>
    </div>
    <div class="row mt-3" *ngIf="stepDetails?.can_edit">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-primary" (click)="updateCstFields()">
          <i class="pi pi-save me-1"></i> Save Q-Bid Details
        </button>
      </div>
    </div>
  </div>

  <!-- Commercial Bid Opening Sheet Section (only for schemeType 'rev' and Q-CST step) -->
  <div class="card shadow-sm border-0 p-4 mb-4" *ngIf="schemeType === 'rev' || stepDetails?.code === 'Q-CST'">
    <div class="tender-opening-sheet-container mb-4">
      <!-- Add Row Button -->
      <div class="mb-3" *ngIf="stepDetails?.can_edit">
        <button class="btn btn-sm btn-primary" (click)="addTableRow()">
          <i class="pi pi-plus me-1"></i> Add Row
        </button>
      </div>

      <!-- TinyMCE Editor -->
      <div class="bg-white p-3 shadow-sm border border-slate-200 rounded">
        <label class="block font-bold text-blue-700 mb-2">Commercial Bid Opening Sheet</label>
        <editor [(ngModel)]="comparative_statement" [init]="init" [disabled]="!stepDetails?.can_edit"></editor>
      </div>
    </div>
  </div>

  <!-- CST Sheet Section (only for schemeType 'rev' and Q-CST step) -->
  <div class="card shadow-sm border-0 p-4 mb-4" *ngIf="schemeType === 'rev' || stepDetails?.code === 'Q-CST'">


    <!-- TinyMCE Editor -->
    <div class="bg-white p-3 shadow-sm border border-slate-200 rounded">
      <label class="block font-bold text-blue-700 mb-2">CST Sheet</label>
      <editor [(ngModel)]="cst_sheet" [init]="init" [disabled]="!stepDetails?.can_edit"></editor>
    </div>
  </div>

  <div class="d-flex bench-price" *ngIf="schemeType != 'tdf'">
    <div class="col-md-6 d-flex gap-4">
      <label class="bg-primary text-white p-2" for="benchmark_price">Benchmark Price <b
          class="text-warning">*</b></label>
      <input id="benchmark_price" [(ngModel)]="benchmark" [disabled]="true" class="form-control w-100" />
    </div>
  </div>

  <div class="overflow-x-auto mt-4">
    <div class="mt-4 mb-4">
      <!-- <p-table [value]="vendors" editMode="row" dataKey="id" #table>
        <ng-template pTemplate="header">
          <tr class="py-2">
            <th>Vendor Name</th>
            <th *ngIf="schemeType != 'idex'">
              Vendor Address
            </th>
            <th *ngIf="schemeType == 'rev' || stepDetails.code =='Q-CST'">With Tax</th>
            <th *ngIf="schemeType == 'rev' || stepDetails.code =='Q-CST'">Tax Percentage</th>
            <th>
              {{ schemeType == "rev" || stepDetails?.code === 'Q-CST' ? "Cost" : "Budgetory Quote" }} (in INR)
            </th>
            <th *ngIf="schemeType == 'rev' || stepDetails.code =='Q-CST'">Final Cost</th>
            <th>Level</th>
            <th *ngIf="schemeType == 'rev' || stepDetails.code =='Q-CST'">
              Concurrence of CST by Finance Rep
            </th>
            <th *ngIf="schemeType == 'rev'">
              Remarks
            </th>
            <th *ngIf=" stepDetails?.can_edit ||  (stepDetails?.step_status != 'approved' && userID == 6) ">
              Actions
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
          <tr [pEditableRow]="rowData" class="py-2">
            <td>{{ rowData.vendor.name }}</td>
            <td *ngIf="schemeType != 'idex'">
              {{ rowData.vendor.address }}
            </td>
            <td *ngIf="schemeType == 'rev' || stepDetails.code =='Q-CST'">
              <ng-container *ngIf="editing; else withTaxView">
                <label class="me-3">
                  <input type="radio" name="with_taxes_{{ri}}" [value]="true" [(ngModel)]="rowData.with_taxes" /> Yes
                </label>
                <label>
                  <input type="radio" name="with_taxes_{{ri}}" [value]="false" [(ngModel)]="rowData.with_taxes" /> No
                </label>
              </ng-container>
              <ng-template #withTaxView>
                {{ rowData.with_taxes ? 'Yes' : 'No' }}
              </ng-template>
            </td>
            <td *ngIf="schemeType == 'rev' || stepDetails.code =='Q-CST'">
              <ng-container *ngIf="editing; else taxPercentView">
                <input type="number" pInputText [(ngModel)]="rowData.tax_percentage" placeholder="Tax %" />
              </ng-container>
              <ng-template #taxPercentView>
                {{ rowData.tax_percentage != null ? rowData.tax_percentage : '-' }}
              </ng-template>
            </td>
            <td *ngIf="schemeType != 'rev' ">
              <ng-container *ngIf="editing; else viewMode">
                <input type="number" pInputText [(ngModel)]="rowData.benchmarkPrice" />
              </ng-container>
              <ng-template #viewMode>
                {{ rowData.benchmarkPrice }}
              </ng-template>
            </td>
            
            <td *ngIf="schemeType ==='rev' || stepDetails?.code ==='Q-CST' ">
              <ng-container *ngIf="editing; else viewMode">
                <input type="number" pInputText [(ngModel)]="rowData.cost_with_taxes" />
              </ng-container>
              <ng-template #viewMode>
                {{ rowData.cost_with_taxes }}
              </ng-template>
            </td>
            <td *ngIf="schemeType == 'rev' || stepDetails.code =='Q-CST'">
              {{ rowData.cost != null ? rowData.cost : '-' }}
            </td>
            <td>{{rowData.final_price}}</td>
            <td>
              {{ rowData.level }}
            </td>
            <td pEditableColumn *ngIf="schemeType == 'rev'">
              <ng-container *ngIf="editing; else viewMode">
                <input type="date" pInputText [(ngModel)]="rowData.date" />
              </ng-container>
              <ng-template #viewMode>
                {{ rowData.concurrence_cst }}
              </ng-template>
            </td>
            <td pEditableColumn *ngIf="schemeType == 'rev'">
              <ng-container *ngIf="editing; else viewMode">
                <input type="text" pInputText [(ngModel)]="rowData.remark" />
              </ng-container>
              <ng-template #viewMode>
                {{ rowData.remark }}
              </ng-template>
            </td>
            <td class="min-wid-150" *ngIf=" stepDetails?.can_edit ">
              <button *ngIf="!editing" type="button" class="btn btn-primary " (click)="table.initRowEdit(rowData)">
                ✏️
              </button>
              <button *ngIf="editing" type="button" class="btn btn-success  mx-2" (click)="onRowEditSave(rowData)">
                ✔
              </button>
              <button *ngIf="editing" type="button" class="btn btn-danger " (click)="table.cancelRowEdit(rowData)">
                ❌
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table> -->

      <p-table [value]="vendors" editMode="row" dataKey="id" #table>
  <ng-template pTemplate="header">
    <tr class="py-2">
      <th>Vendor Name</th>
      <th *ngIf="schemeType != 'idex'">Vendor Address</th>
      <th *ngIf="schemeType == 'rev' || stepDetails?.code == 'Q-CST'">With Tax</th>
      <th *ngIf="schemeType == 'rev' || stepDetails?.code == 'Q-CST'">Tax Percentage</th>
      <th>
        {{ schemeType == 'rev' || stepDetails?.code === 'Q-CST' ? 'Cost' : 'Budgetory Quote' }} (in INR)
      </th>
      <th *ngIf="schemeType == 'rev' || stepDetails?.code == 'Q-CST'">Final Cost</th>
      <th>Level</th>
      <th *ngIf="schemeType == 'rev' || stepDetails?.code == 'Q-CST'">
        Concurrence of CST by Finance Rep
      </th>
      <th *ngIf="schemeType == 'rev'">Remarks</th>
      <th *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
        Actions
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="rowData" class="py-2">

      <!-- Vendor Name -->
      <td>{{ rowData.vendor.name }}</td>

      <!-- Vendor Address -->
      <td *ngIf="schemeType != 'idex'">
        {{ rowData.vendor.address != null ? rowData.vendor.address : '-' }}
      </td>

      <!-- With Tax -->
      <td *ngIf="schemeType == 'rev' || stepDetails?.code == 'Q-CST'">
        <ng-container *ngIf="editing; else withTaxView">
          <label class="me-3">
            <input type="radio" name="with_taxes_{{ri}}" [value]="true" [(ngModel)]="rowData.with_taxes" /> Yes
          </label>
          <label>
            <input type="radio" name="with_taxes_{{ri}}" [value]="false" [(ngModel)]="rowData.with_taxes" /> No
          </label>
        </ng-container>
        <ng-template #withTaxView>
          {{ rowData.with_taxes ? 'Yes' : 'No' }}
        </ng-template>
      </td>

      <!-- Tax Percentage — NOTE: API key is 'tax_percantage' (typo in backend) -->
      <td *ngIf="schemeType == 'rev' || stepDetails?.code == 'Q-CST'">
        <ng-container *ngIf="editing; else taxPercentView">
          <input type="number" pInputText [(ngModel)]="rowData.tax_percantage" placeholder="Tax %" />
        </ng-container>
        <ng-template #taxPercentView>
          {{ rowData.tax_percantage != null ? rowData.tax_percantage : '-' }}
        </ng-template>
      </td>

      <!-- Cost / Budgetory Quote (single column) -->
      <td>
        <ng-container *ngIf="schemeType == 'rev' || stepDetails?.code == 'Q-CST'; else budgetaryQuoteCell">
          <!-- rev / Q-CST: cost_with_taxes -->
          <ng-container *ngIf="editing; else costWithTaxView">
            <input type="number" pInputText [(ngModel)]="rowData.cost_with_taxes" />
          </ng-container>
          <ng-template #costWithTaxView>
            {{ rowData.cost_with_taxes != null ? rowData.cost_with_taxes : '-' }}
          </ng-template>
        </ng-container>
        <!-- Other schemes: benchmark_price (FIXED: was benchmarkPrice) -->
        <ng-template #budgetaryQuoteCell>
          <ng-container *ngIf="editing; else benchmarkView">
            <input type="number" pInputText [(ngModel)]="rowData.benchmark_price" />
          </ng-container>
          <ng-template #benchmarkView>
            {{ rowData.benchmark_price != null ? rowData.benchmark_price : '-' }}
          </ng-template>
        </ng-template>
      </td>

      <!-- Final Cost — maps to 'cost' field from API -->
      <td *ngIf="schemeType == 'rev' || stepDetails?.code == 'Q-CST'">
        {{ rowData.cost != null ? rowData.cost : '-' }}
      </td>

      <!-- Level -->
      <td>{{ rowData.level != null ? rowData.level : '-' }}</td>

      <!-- Concurrence of CST by Finance Rep -->
      <td *ngIf="schemeType == 'rev' || stepDetails?.code == 'Q-CST'">
        <ng-container *ngIf="editing; else concurrenceView">
          <input type="date" pInputText [(ngModel)]="rowData.date" />
        </ng-container>
        <ng-template #concurrenceView>
          {{ rowData.concurrence_cst != null ? rowData.concurrence_cst : '-' }}
        </ng-template>
      </td>

      <!-- Remarks -->
      <td *ngIf="schemeType == 'rev'">
        <ng-container *ngIf="editing; else remarkView">
          <input type="text" pInputText [(ngModel)]="rowData.remark" />
        </ng-container>
        <ng-template #remarkView>
          {{ rowData.remark != null ? rowData.remark : '-' }}
        </ng-template>
      </td>

      <!-- Actions -->
      <td class="min-wid-150"
          *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
        <button *ngIf="!editing" type="button" class="btn btn-primary"
                (click)="table.initRowEdit(rowData)">✏️</button>
        <button *ngIf="editing" type="button" class="btn btn-success mx-2"
                (click)="onRowEditSave(rowData)">✔</button>
        <button *ngIf="editing" type="button" class="btn btn-danger"
                (click)="table.cancelRowEdit(rowData)">❌</button>
      </td>

    </tr>
  </ng-template>
</p-table>
    </div>
  </div>
  <div class="row mb-4" *ngIf="stepDetails.code == 'Q-CST'">
    <div class="col-md-12">
      <div class="row mb-4">
        <div class="d-flex align-items-center mb-3">
          <i class="bi bi-file-earmark-text text-primary me-2"></i>
          <h5 class="card-title mb-0">CST Document</h5>
        </div>
        <app-upload-document [title]="'CST Document'" [isEditable]="stepDetails?.can_edit"></app-upload-document>
      </div>
    </div>
  </div>
  <!-- <div class="mt-4" >
    <form [formGroup]="CSTForm">
      <div class="editor-field">
        <b class="form-label-left">Comparative Statement of Tenders</b>
        <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
      </div>
    </form>
  </div> -->
  <div class="mt-4">
    <form [formGroup]="CSTForm">
      <div class="editor-field">

        <!-- Hide b label when schemeType is makeI, makeII, makeIII -->
        <b class="form-label-left" *ngIf="!['makeI', 'makeII', 'makeIII'].includes(schemeType)">
          Comparative Statement of Tenders
        </b>
        <b class="form-label-left" *ngIf="['makeI', 'makeII', 'makeIII'].includes(schemeType)">
          Comments
        </b>

        <!-- Editor always shown -->
        <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>

      </div>
    </form>
  </div>

</div>